import { CircularProgress, makeStyles } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MessagesContext from '../../contexts/messagesContext';
import {
    addNewField,
    deleteSearchReport,
    getSearch,
    resetFields
} from '../../redux/Search/SearchAction';
import { PlusIcon } from '../../components/UI/Icons';
import SearchField from '../../components/AdvancedSearch/Fields';
import Result from '../../components/AdvancedSearch/Result';
import { MainDialog, SubmitButton } from '../../components/UI';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/Search/SearchType';
import { ArrowBottomIcon } from '../../components/UI/Images/Icons';
import DownloadReports from '../../components/AdvancedSearch/Result/resultHeader/downloadReports';

const styles = makeStyles({
    newField: {
        width: '85px',
        display: 'flex',
        alignItems: 'center',
        color: '  #509ffa',
        fontWeight: 'bold',
        cursor: 'pointer',
        // marginTop: '12px',
        '& > svg': {
            width: '12px',
            height: '12px',
            marginInlineEnd: '5px'
        }
    },
    fieldContainer: {
        marginBottom: '15px'
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end'
    },
    searchBtnWrapper: {
        width: '270px',
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 300px)'
    },
    button: {
        minWidth: '140px',
        // height: '40px',
        padding: '8px 12px',
        borderRadius: '6px',
        border: '1.5px solid #416ce1',
        backgroundColor: '#fff',
        fontFamily: 'inherit',
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#416ce1',
        // marginInlineStart: '8px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
});

const AdvancedSearch = () => {
    const { messages } = useContext(MessagesContext);
    const classes = styles();
    const fields = useSelector((state) => state.search.fields);
    const length = fields?.length;
    const dispatch = useDispatch();
    const list = useSelector((state) => state.search.searchResult);
    const loadingSelector = createLoadingSelector(type.SEARCH_FORM_REQUEST);
    const isLoading = useSelector(loadingSelector);
    const hasValue = fields?.every((item) => item.value && !item.errorMessage);
    const reports = useSelector((state) => state?.search?.reports);
    const [dialog, setDialog] = useState(false);
    const [clinic, setClinic] = useState(null);
    const [isInvalid, setIsInvalid] = useState(false);

    const handleAddField = () => {
        const lastIndex = fields[fields.length - 1]?.index;
        const index = lastIndex + 1;
        if (fields?.length < 10) {
            dispatch(addNewField(index));
        }
    };

    useEffect(() => {
        return () => dispatch(resetFields());
    }, []);

    const handleSearch = () => {
        if (fields?.some((item) => item.value) && clinic) {
            dispatch(getSearch(clinic));

            setIsInvalid(false);
        } else {
            setIsInvalid(true);
        }
    };
    const handleDeleteExport = (exportId) => {
        dispatch(deleteSearchReport(exportId));
    };

    return (
        <>
            <MainDialog open={dialog} goBack={() => setDialog(false)}>
                <DownloadReports reports={reports} handleDeleteExport={handleDeleteExport} />
            </MainDialog>
            {/* <h3>{messages.alertMessage}</h3> */}
            <div className={classes.row}>
                <div>
                    {fields?.map((field) => (
                        <div className={classes.fieldContainer} key={field.index}>
                            <SearchField
                                item={field}
                                length={length}
                                isInvalid={isInvalid}
                                handleSelectClinic={({ id }) => {
                                    setClinic(id);
                                    setIsInvalid(false);
                                }}
                            />
                        </div>
                    ))}
                </div>
                <div className={classes.searchBtnWrapper}>
                    <SubmitButton
                        isButton
                        handleClick={handleSearch}
                        submitText={messages.search}
                        mr={'0'}
                        // fullWidth
                        data-testid="search"
                        width="120"
                    />
                    <button
                        className={classes.button}
                        onClick={() => setDialog(true)}
                        // disabled={firstReport?.export_status !== 'G' || isLoading}
                    >
                        {messages.listOfReports}
                        <ArrowBottomIcon color="#416ce1" />
                    </button>
                </div>
            </div>
            {fields?.length < 10 && hasValue && (
                <span className={classes.newField} onClick={handleAddField}>
                    <PlusIcon width="12px" height="12px" color="#509ffa" />
                    {messages.newField}
                </span>
            )}

            {list === null && isLoading ? (
                <div className={classes.loadingContainer}>
                    <CircularProgress />
                </div>
            ) : (
                list !== null && <Result setDownloadDialog={setDialog} />
            )}
        </>
    );
};

export default AdvancedSearch;
